import React from "react";
import "./MainSection.css";

export type MainSectionProps = {
  id: string;
  header: string;
  children: React.ReactNode;
};

const MainSection: React.FC<MainSectionProps> = (props) => (
  <section id={props.id} className="main__section">
    <h2 className="section__title">{props.header}</h2>
    {props.children}
    <span className="section__sep">[SEP]</span>
  </section>
);

export default MainSection;
